import React from "react";
import "./VirtualRemodeler.scss";
import Breadcrumb from "../../../components/breadcrumb/Breadcrumb";
export default function VirtualRemodeler() {
  return (
    <div>
       <Breadcrumb />
      <iframe
        title="virtual remodeler"
        height="1000px"
        name="iFrame Name"
        src="https://www.gaf.com/en-us/roof-design/gaf-home-remodeler?cbviewer=5"
        style={{ border: "none" }}
        width="100%"
      ></iframe>
    </div>
  );
}

